import { HostName } from "app-shell/NavBar/NavBar.tsx";
import { FC } from "react";

import { MessageBar, MessageBarType } from "@bps/fluent-ui";
import { Permission } from "@libs/gateways/core/CoreGateway.dtos.ts";
import { useStores } from "@stores/hooks/useStores.ts";

export const AccEnvMessageBar: FC = () => {
  const {
    core,
    core: { isNZTenant }
  } = useStores();

  const isProduction = Array.from(Object.values(HostName)).every(
    name => !window.location.hostname.startsWith(name)
  );

  const isAccAllowed = core.hasPermissions(Permission.AccLiveAllowed);
  if (!isNZTenant) return null;

  if (isProduction && !isAccAllowed) {
    return (
      <MessageBar messageBarType={MessageBarType.warning}>
        <strong> Connected to ACC compliance environment: </strong>
        If this is not a trial tenant please contact Bp to enable ACC and submit
        claims successfully
      </MessageBar>
    );
  }

  if (isAccAllowed && !isProduction) {
    return (
      <MessageBar messageBarType={MessageBarType.warning}>
        <strong> Stop now! </strong>Your test environment is connected to ACC
        production environment. Please contact Bp support immediately
      </MessageBar>
    );
  }

  return null;
};
